import { type FC, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ConfirmDrawer } from "web_myplann/Shared/Components/ConfirmDrawer";
import { FlatRowSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowSwitch";

const R = Resources.Finances.TurnOffDetailDialog;

type Props = {
	label: string;
	checked: boolean;
	hasItems: boolean;
	onChange: (checked: boolean) => void;
};

export const DetailedEntrySwitch: FC<Props> = ({
	label,
	checked,
	hasItems,
	onChange,
}) => {
	const { t } = useResource();
	const [isConfirmOpen, setIsConfirmOpen] = useState(false);

	const handleChange = (nextChecked: boolean) => {
		if (!nextChecked && hasItems) {
			setIsConfirmOpen(true);
			return;
		}
		onChange(nextChecked);
	};

	const turnOff = () => {
		setIsConfirmOpen(false);
		onChange(false);
	};

	return (
		<>
			<FlatRowSwitch
				redesigned
				labelVariant="bodyMedium"
				label={label}
				checked={checked}
				onChange={handleChange}
				isLast
			/>
			<ConfirmDrawer
				open={isConfirmOpen}
				title={t(R.title)}
				description={t(R.description)}
				confirmLabel={t(R.turnOff)}
				cancelLabel={t(R.keep)}
				cancelAsLink
				grabber
				onConfirm={turnOff}
				onClose={() => setIsConfirmOpen(false)}
			/>
		</>
	);
};
